import { BlueConicAlgorithm } from '@pushly/models/lib/enums/recommendations/blueconic/blueconic-algorithm'
import { BlueConicFilterType } from './filters/enums'
import { BlueConicAlgorithmRampUp } from '@pushly/models/lib/enums'
import { BlueConicRecommendationConfiguration } from '@pushly/models/lib/structs/journeys'

export const BLUECONIC_DISPLAY_VALUE = 'BlueConic'
export const BLUECONIC_BOOST_DISPLAY_NAMES = {
    [BlueConicAlgorithm.COLLABORATIVE_FILTERING]: 'Collaborative filtering',
    [BlueConicAlgorithm.INTEREST]: 'Same interest',
    [BlueConicAlgorithm.LOOK_ALIKE]: 'Look-alike-articles',
    [BlueConicAlgorithm.RECENCY]: 'Recency',
    [BlueConicAlgorithm.RECENT_CTR]: 'Recent high CTRs',
    [BlueConicAlgorithm.RECENT_ENTRYPAGE]: 'Viral news',
    [BlueConicAlgorithm.RECENT_VIEW]: 'Breaking news',
    [BlueConicAlgorithm.RECENTLY_BOUGHT]: 'Recently bought items',
    [BlueConicAlgorithm.RECENTLY_SHOPPINGCART]: 'Recently carted items',
    [BlueConicAlgorithm.RECENTLY_VIEWED]: 'Seen articles',
    [BlueConicAlgorithm.SAME_CATEGORY]: 'Same category',
}

export const BLUECONIC_FILTER_DISPLAY_NAMES = {
    [BlueConicFilterType.PRODUCTS]: 'Products',
    [BlueConicFilterType.CATEGORY]: 'Category',
    [BlueConicFilterType.KEYWORD]: 'Keyword',
    [BlueConicFilterType.AUTHOR]: 'Author',
    [BlueConicFilterType.SITENAME]: 'Sitename',
    [BlueConicFilterType.PUBLICATION_DATE]: 'Publication Date',
    [BlueConicFilterType.PROPERTY]: 'Has Property',
    [BlueConicFilterType.CUSTOM]: 'Custom Property',
}

export const ORDERED_BLUECONIC_ALGORITHM_RAMP_UP_OPTIONS = [
    BlueConicAlgorithmRampUp.VERY_SLOW,
    BlueConicAlgorithmRampUp.SLOW,
    BlueConicAlgorithmRampUp.NORMAL,
    BlueConicAlgorithmRampUp.FAST,
    BlueConicAlgorithmRampUp.INSTANT,
]

export const MAX_BLUECONIC_RECOMMENDATION_CONIGS_ALLOWED = 6
export const MAX_META_FILTERS_VALUE = 10
export const MAX_PRODUCT_FILTERS_VALUE = 4

export const INDEX_DISPLAY_DEFAULT_ID = {
    0: 'first',
    1: 'second',
    2: 'third',
    3: 'fourth',
    4: 'fifth',
    5: 'sixth',
}

export const defaultBlueConicConfigurationValue = BlueConicRecommendationConfiguration.from({
    boosts: [],
    filters: { and: [] },
    id: 'first',
    count: 1,
})

export const DEFAULT_BLUECONIC_BOOST_VALUE = '5'
